// extracted by mini-css-extract-plugin
export default {"container":"CompanyItem_container__mDHby","content":"CompanyItem_content__qiKuh","name":"CompanyItem_name__rt7W8","location":"CompanyItem_location__jHEU2"};